import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { createComment } from '../../actions/create-comment';
import { emitTypingThrottled, clearTypingUsers } from '../../actions/typing-socket';
import { upload, TYPE_IMAGE } from '../../actions/upload';
import { cancelUploads } from '../../actions/cancel-uploads';
import { stopEditingComment } from '../../actions/stop-editing-comment';
import CardOverlay from '../../components/card-overlay';
import PostPageFooterWrapper from '../../components/post-page-footer-wrapper';
import CommentBar from '../../components/comment-bar';
import CommentForm from '../../components/comment-form';
import LoginToComment from '../../components/login-to-comment';
import { HorizontalSeparator } from '../../components/separator';
import TypingList from '../../components/typing-list';
import forMobileOnly from '../../hoc/for-mobile-only';
import withAuth from '../../hoc/with-auth';
import withDeviceType from '../../hoc/with-device-type';
import { getTypingUsers } from '../../selectors/typing-selectors';
import { isEditingComment } from '../../selectors/edited-comment-id-selectors';
import processImage from '../../services/process-image';

const MobileSeparator = forMobileOnly(HorizontalSeparator);

export class PostPageFooter extends Component {
  componentWillUnmount = () => {
    this.props.clearTypingUsers();
    this.props.cancelUploads();
  };

  handleCommentChange = () => this.props.emitTyping(this.props.currentUser, { _id: this.props.postId });

  handleCommentFormSubmit = comment =>
    this.props.createComment(this.props.postId, comment).then(() => {
      this.props.onCommentCreate();
    });

  handleCommentImageChange = file =>
    processImage(file).then(({ dataUrl }) => {
      this.props.change('comment', 'image', dataUrl);
      this.props.upload(dataUrl, TYPE_IMAGE, file => change('comment', 'image', file));
    });

  handleCommentImageDelete = () => {
    this.props.change('comment', 'image', null);
  };

  getInitialFormValues = () => ({
    ownerId: this.props.currentUser._id,
  });

  renderCommentBar = () => (
    <CommentBar
      initialValues={this.getInitialFormValues()}
      onChange={this.handleCommentChange}
      onSubmit={this.handleCommentFormSubmit}
      onImageChange={this.handleCommentImageChange}
      onImageDelete={this.handleCommentImageDelete}
    />
  );

  renderCommentForm = () => (
    <CommentForm
      initialValues={this.getInitialFormValues()}
      onChange={this.handleCommentChange}
      onSubmit={this.handleCommentFormSubmit}
      shouldDisableButton={!this.props.isEditingComment}
    />
  );

  render = () => {
    const {
      isMobile,
      isAuthenticated,
      typingUsers,
      isSticky,
      stickyThreshold,
      isEditingComment,
      stopEditingComment,
      postId,
    } = this.props;
    let content;

    if (!postId) {
      return null;
    }

    if (isAuthenticated) {
      content = isMobile ? this.renderCommentBar() : this.renderCommentForm();
    } else {
      content = <LoginToComment />;
    }

    return (
      <PostPageFooterWrapper
        isMobile={isMobile}
        isSticky={isSticky}
        stickyThreshold={stickyThreshold}
        isTyping={Boolean(typingUsers.length)}
      >
        {isEditingComment && !isMobile ? <CardOverlay onClick={stopEditingComment} /> : null}
        <TypingList users={typingUsers} />
        {content}
        <MobileSeparator />
      </PostPageFooterWrapper>
    );
  };
}

PostPageFooter.propTypes = {
  postId: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  currentUser: PropTypes.object,
  isAuthenticated: PropTypes.bool.isRequired,
  isSticky: PropTypes.bool,
  stickyThreshold: PropTypes.number,
  typingUsers: PropTypes.array.isRequired,
  emitTyping: PropTypes.func.isRequired,
  upload: PropTypes.func.isRequired,
  cancelUploads: PropTypes.func.isRequired,
  clearTypingUsers: PropTypes.func.isRequired,
  createComment: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  onCommentCreate: PropTypes.func.isRequired,
  stopEditingComment: PropTypes.func.isRequired,
  isEditingComment: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  typingUsers: getTypingUsers(state),
  isEditingComment: isEditingComment(state),
});

PostPageFooter.defaultProps = {
  onCommentCreate: () => {},
};
const mapDispatchToProps = {
  createComment,
  emitTyping: emitTypingThrottled,
  clearTypingUsers,
  upload,
  change,
  cancelUploads,
  stopEditingComment,
};

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withAuth,
  withDeviceType,
)(PostPageFooter);
